import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import moment from 'moment'
import { Field, Form } from 'react-final-form'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import InputAdornment from '@material-ui/core/InputAdornment'
import withPromise from 'helpers/withPromise'
import Psfs from 'lib/psfs/Psfs'
import DatePickerInput from 'components/common/Form/DatePicker'
import TimePickerInput from 'components/common/Form/TimePicker'
import SelectInput from 'components/common/Form/SelectInput'
import TextArea from 'components/common/Form/TextArea'
import Input from 'components/common/Form/Input'
import {
  fetchEventFormInfo,
  fetchEventFormList,
  fetchLocusGroupsList,
  saveEventForm,
  openEventFormModal,
  fetchEventDataList,
} from 'reducers/logbook/reducer'
import { fetchActiveCages } from 'reducers/digitalLogbook/reducer'
import { uploadFiles, removeFiles } from 'reducers/common/files/reducer'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import {
  TYPE_LIST,
  TYPE_CONSTANT_VALUE,
  TYPE_INPUT_NUMBER,
  getFileObject,
  ifLogbookConstant,
} from 'helpers/logbook'
import { LOGBOOK_REGULAR } from 'constants/requestTypes'
import messages from './translate'

class EventCreateForm extends Component {
  constructor(props) {
    super(props)
    const { activeSite, siteList } = props
    const basicSite = activeSite || (siteList.size > 0 ? siteList.get(0).id : 0)
    const now = moment()
    this.state = {
      site: basicSite,
      event_date: now,
      start_time: now,
      end_time: now,
      category: 0,
      event: 0,
      events: [],
      result: null,
      cage: null,
      locus_group: null,
      comment: '',
      file: getFileObject(),
    }
  }

  componentDidMount() {
    const {
      fetchEventFormList,
      fetchLocusGroupsList,
      fetchActiveCages,
    } = this.props
    const { site } = this.state

    fetchEventFormList({
      type: LOGBOOK_REGULAR,
      site,
    })

    const psfs = new Psfs()
    psfs.addFilter('site', site)
    psfs.addFilter('visibleInUi', true)
    fetchLocusGroupsList({ psfs })

    if (site) {
      psfs.addFields(['id', 'containerName'])
      fetchActiveCages({ psfs })
    }
  }

  shouldComponentUpdate(nextProps) {
    const {
      intl: { formatMessage },
      fetchActiveCages,
      siteList,
      locusGroupList,
      locusList,
      formLists,
      eventInfo,
    } = this.props
    const {
      locusGroupList: nextLocusGroupList,
      locusList: nextLocusList,
      formLists: nextFormLists,
      eventInfo: nextEventInfo,
      siteList: nextSiteList,
    } = nextProps

    if (siteList !== nextSiteList) {
      const site = nextSiteList.size > 0 ? nextSiteList.get(0).id : null

      this.setState({ site }, () => {
        if (site) {
          const psfs = new Psfs()
          psfs.addFilter('site', site)
          psfs.addFields(['id', 'containerName'])
          fetchActiveCages({ psfs })
        }
      })

      return false
    }

    if (locusGroupList !== nextLocusGroupList) {
      const locus_group =
        nextLocusGroupList.size > 0 ? nextLocusGroupList.get(0).id : null
      this.setState({ locus_group })

      return false
    }

    if (locusList !== nextLocusList) {
      const cage = nextLocusList.size > 0 ? nextLocusList.get(0).id : null
      this.setState({ cage })

      return false
    }

    if (formLists !== nextFormLists) {
      const categories = nextFormLists.get('categories').toJS()
      const category = categories.length ? categories[0].id : 0
      this.setCategoryState(category, nextFormLists.get('events').toJS())

      return false
    }

    if (eventInfo !== nextEventInfo) {
      const eventInfo = nextEventInfo.toJS()

      let result = null

      if (eventInfo.type === TYPE_CONSTANT_VALUE)
        result = ifLogbookConstant(formatMessage)(
          eventInfo.parameters.constant_value,
        )

      if (eventInfo.type === TYPE_LIST) [result] = eventInfo.parameters.options

      this.setState({ result })

      return false
    }

    return true
  }

  getOptionsForEvents = (categoryId, events) => {
    const options = []

    for (const key in events) {
      if (Object.prototype.hasOwnProperty.call(events, key)) {
        const event = events[key]

        if (event.category_id === categoryId) {
          options.push(event)
        }
      }
    }

    return options
  }

  onSiteChange = e => {
    const {
      fetchLocusGroupsList,
      fetchActiveCages,
      fetchEventFormList,
    } = this.props
    const site = e.target.value

    if (site) {
      this.setState({ site }, () => {
        const psfs = new Psfs()
        psfs.addFilter('site', site)
        fetchLocusGroupsList({ psfs })
        psfs.addFields(['id', 'containerName'])
        fetchActiveCages({ psfs })
        fetchEventFormList({
          type: LOGBOOK_REGULAR,
          site,
        })
      })
    }
  }

  onCageChange = e => this.setState({ cage: e.target.value })

  onLocusGroupChange = e => this.setState({ locus_group: e.target.value })

  onEventDateChange = date => {
    if (date) {
      this.setState({ event_date: moment(date) })
    }
  }

  onEventStartTimeChange = time => {
    if (time) {
      this.setState({ start_time: moment(time) })
    }
  }

  onEventEndTimeChange = time => {
    if (time) {
      this.setState({ end_time: moment(time) })
    }
  }

  setCategoryState = (category, eventsList) => {
    const events = this.getOptionsForEvents(category, eventsList)
    const event = events.length ? events[0].id : 0
    const { site } = this.state

    this.setState({ category, event, events }, () => {
      if (event) {
        this.props.fetchEventFormInfo({
          type: LOGBOOK_REGULAR,
          event,
          site,
        })
      }
    })
  }

  onCategoryChange = e => {
    this.setCategoryState(
      e.target.value,
      this.props.formLists.get('events').toJS(),
    )
  }

  onEventChange = e => {
    const event = e.target.value
    const { site } = this.state

    this.setState({ event }, () => {
      this.props.fetchEventFormInfo({
        type: LOGBOOK_REGULAR,
        event,
        site,
      })
    })
  }

  onResultSelectChange = e => this.setState({ result: e.target.value })

  onResultKeyUp = event => {
    let { value } = event.target

    if (value !== '-' && !/^-?[0-9]{1,10}(.[0-9]{0,2})?$/.test(value)) {
      const eventInfo = this.props.eventInfo.toJS()
      const digit = 10 ** (eventInfo ? eventInfo.parameters.decimals : 2)
      value = parseFloat(value)
      // eslint-disable-next-line no-restricted-globals
      value = isNaN(value) ? 0 : Math.round(value * digit) / digit
    }

    this.setState({ result: value })
  }

  formatDigitValue = value => {
    if (value === undefined || value === null || value === '0') return 0
    if (value === '-' || value === '-0' || value === '-0.') return value
    if (value === '-.') return '-0.'
    if (value === '0-') return '-'

    const lastKey = String(value).slice(-1)
    const oldValue = String(value).slice(0, -1)

    if (/^[0-9.]$/.test(lastKey)) {
      return value
    }

    return oldValue
  }

  onCommentChange = e => this.setState({ comment: e.target.value })

  onChangeFile = e => {
    const {
      showNotice,
      uploadFiles,
      intl: { formatMessage },
    } = this.props
    const [file] = e.currentTarget.files

    if (!file) {
      return false
    }

    const fileForm = new FormData()
    fileForm.append('file', file)

    withPromise(uploadFiles, {
      file: fileForm,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        this.setState({
          file: response,
        })
      }
    })
  }

  onRemoveFile = () => {
    const { file } = this.state

    withPromise(this.props.removeFiles, {
      id: file.id,
    }).then(({ error }) => {
      if (!error) {
        this.setState({
          file: getFileObject(),
        })
      }
    })
  }

  onSubmit = values => {
    const {
      eventInfo: evtInfo,
      openEventFormModal,
      saveEventForm,
      fetchEventDataList,
      activeSite,
      activeDate,
    } = this.props
    const eventInfo = evtInfo.toJS()
    const form = {
      site: values.site,
      event: values.event,
      result: values.result,
      event_date: null,
      start_time: null,
      end_time: null,
      locus: null,
      locus_group: null,
      comment: null,
      file: null,
    }

    if (eventInfo.type === TYPE_INPUT_NUMBER) {
      form.result = parseFloat(values.result)
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(form.result)) {
        form.result = 0
      }
    }

    if (eventInfo.type === TYPE_CONSTANT_VALUE) {
      form.result = eventInfo.parameters.constant_value
    }

    if (eventInfo.needs_event_date)
      form.event_date = values.event_date.format('YYYY-MM-DD')

    if (eventInfo.needs_start_time)
      form.start_time = values.start_time.format('HH:mm:ss')

    if (eventInfo.needs_end_time)
      form.end_time = values.end_time.format('HH:mm:ss')

    if (eventInfo.needs_locus) form.locus = values.cage

    if (eventInfo.needs_locus_group) form.locus_group = values.locus_group

    if (eventInfo.needs_comment) form.comment = values.comment

    if (eventInfo.needs_file) form.file = values.file.id

    return withPromise(saveEventForm, {
      params: {
        type: LOGBOOK_REGULAR,
      },
      form,
      id: null,
    }).then(errors => {
      if (errors) {
        return Promise.resolve(errors)
      }

      openEventFormModal({
        isOpen: false,
        type: null,
      })
      fetchEventDataList({
        type: LOGBOOK_REGULAR,
        params: {
          site: activeSite,
          date: activeDate.format('YYYY-MM-DD'),
        },
      })
    })
  }

  render() {
    const {
      eventInfo: evtInfo,
      siteList,
      locusList,
      formLists,
      locusGroupList,
      intl: { formatMessage },
    } = this.props
    const { events, file } = this.state
    const eventInfo = evtInfo.toJS()
    const startTimeLabel = formatMessage(
      eventInfo.needs_start_time && eventInfo.needs_end_time
        ? messages.startTime
        : messages.time,
    )

    const formData = {
      sites: siteList.toJS(),
      categories: formLists.get('categories').toJS(),
      events,
      locusList: locusList.toJS(),
      locusGroupList: locusGroupList.toJS(),
    }

    return (
      <Form
        onSubmit={this.onSubmit}
        initialValues={this.state}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} className="event-form">
            <Field
              name="site"
              component={SelectInput}
              label={formatMessage(messages.selectSite)}
              onChange={this.onSiteChange}
              formControlProps={{
                fullWidth: true,
                required: true,
              }}>
              {formData.sites.map((site, i) => (
                <MenuItem button key={i} component="li" value={site.id}>
                  {site.name}
                </MenuItem>
              ))}
            </Field>

            {Boolean(eventInfo.needs_event_date) && (
              <Field
                name="event_date"
                type="text"
                label={formatMessage(messages.date)}
                component={DatePickerInput}
                disabled={submitting}
                onChange={this.onEventDateChange}
              />
            )}

            {Boolean(eventInfo.needs_start_time) && (
              <Field
                name="start_time"
                type="text"
                label={startTimeLabel}
                component={TimePickerInput}
                disabled={submitting}
                onChange={this.onEventStartTimeChange}
              />
            )}

            {Boolean(eventInfo.needs_end_time) && (
              <Field
                name="end_time"
                type="text"
                label={formatMessage(messages.endTime)}
                component={TimePickerInput}
                disabled={submitting}
                onChange={this.onEventEndTimeChange}
              />
            )}

            <Field
              name="category"
              component={SelectInput}
              label={formatMessage(messages.category)}
              onChange={this.onCategoryChange}
              formControlProps={{
                fullWidth: true,
                required: true,
              }}>
              {formData.categories.map((category, i) => (
                <MenuItem button key={i} component="li" value={category.id}>
                  {ifLogbookConstant(formatMessage)(category.title)}
                </MenuItem>
              ))}
            </Field>

            <Field
              name="event"
              component={SelectInput}
              label={formatMessage(messages.event)}
              onChange={this.onEventChange}
              formControlProps={{
                fullWidth: true,
                required: true,
              }}>
              {formData.events.map((event, i) => (
                <MenuItem button key={i} component="li" value={event.id}>
                  {ifLogbookConstant(formatMessage)(event.title)}
                </MenuItem>
              ))}
            </Field>

            {eventInfo.type === TYPE_LIST && (
              <Field
                name="result"
                component={SelectInput}
                label={formatMessage(messages.result)}
                onChange={this.onResultSelectChange}
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}>
                {Object.keys(eventInfo.options).map((result, i) => (
                  <MenuItem button key={i} component="li" value={result}>
                    {ifLogbookConstant(formatMessage)(
                      eventInfo.options[result],
                    )}
                  </MenuItem>
                ))}
              </Field>
            )}

            {eventInfo.type === TYPE_CONSTANT_VALUE && (
              <Field
                disabled
                name="result"
                type="text"
                label={formatMessage(messages.result)}
                component={Input}
                className="form-control"
              />
            )}

            {eventInfo.type === TYPE_INPUT_NUMBER && (
              <Field
                name="result"
                type="text"
                label={formatMessage(messages.result)}
                component={Input}
                className="form-control"
                onKeyUp={this.onResultKeyUp}
                format={this.formatDigitValue}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {ifLogbookConstant(formatMessage)(
                        eventInfo.parameters.unit,
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            )}

            {Boolean(eventInfo.needs_locus_group) && (
              <Field
                name="locus_group"
                component={SelectInput}
                label={formatMessage(messages.selectLocusGroup)}
                disabled={submitting}
                onChange={this.onLocusGroupChange}
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}>
                {formData.locusGroupList.map((group, i) => (
                  <MenuItem button key={i} component="li" value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
              </Field>
            )}

            {Boolean(eventInfo.needs_locus) && (
              <Field
                name="cage"
                component={SelectInput}
                label={formatMessage(messages.selectLocus)}
                disabled={submitting}
                onChange={this.onCageChange}
                formControlProps={{
                  fullWidth: true,
                  required: true,
                }}>
                {formData.locusList.map((locus, i) => (
                  <MenuItem button key={i} component="li" value={locus.id}>
                    {locus.containerName}
                  </MenuItem>
                ))}
              </Field>
            )}

            {Boolean(eventInfo.needs_comment) && (
              <Field
                multiline
                name="comment"
                label={formatMessage(messages.addComment)}
                component={TextArea}
                inputProps={{
                  onChange: this.onCommentChange,
                }}
              />
            )}

            {Boolean(eventInfo.needs_file) && (
              <div className="form-group">
                <div className="event-file-change">
                  {Boolean(file.id) && (
                    <div className="event-file-uploaded">
                      <a
                        href={file.uri}
                        target="_blank"
                        rel="noopener noreferrer">
                        <span>
                          <Icon>attach_file</Icon>
                          {file.originalName}
                        </span>
                      </a>
                      <Icon onClick={this.onRemoveFile}>clear</Icon>
                    </div>
                  )}
                  {!file.id && (
                    <>
                      <label htmlFor="eventFile">
                        {formatMessage(messages.uploadPdfPngJpg)}
                      </label>
                      <input
                        id="eventFile"
                        type="file"
                        onChange={this.onChangeFile}
                        style={{
                          display: 'none',
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="form-group">
              <Button
                href={null}
                type="submit"
                color="primary"
                size="medium"
                variant="contained"
                onClick={handleSubmit}>
                <FormattedMessage {...messages.save} />
              </Button>
            </div>
          </form>
        )}
      />
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['site', 'listData']),
    locusList: state.getIn(['digitalLogbook', 'locusList']),
    formLists: state.getIn(['logbook', 'formLists']),
    eventInfo: state.getIn(['logbook', 'eventInfo']),
    locusGroupList: state.getIn(['logbook', 'locusGroupList']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
  }),
  {
    fetchActiveCages,
    fetchEventFormInfo,
    fetchEventFormList,
    fetchLocusGroupsList,
    saveEventForm,
    openEventFormModal,
    fetchEventDataList,
    showNotice,
    uploadFiles,
    removeFiles,
  },
)(injectIntl(EventCreateForm))
